import {FunctionComponent, useEffect} from "react";
import "./index.scss";
import {Tabs} from 'antd';
import {ProcessDocument} from "./process-document";
import {useDispatch} from "react-redux";
import {AppSideBarPageActions, SideBarOptions} from "../../parts/AppSideBar/model";
import {PageTitle} from "../../components/page-title";


export const UserGuide: FunctionComponent = () => {
  const {TabPane} = Tabs;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AppSideBarPageActions.updateSelectedSideBar(SideBarOptions.USER_GUIDE));
  }, []);

  return (
    <div className={"UserGuide"}>
      <PageTitle title="User Guide"/>
      <Tabs defaultActiveKey="process-document" className={"user-guide-tabs"}>
        <TabPane
          tab={"Process Document"}
          key="process-document"
        >
          <ProcessDocument/>
        </TabPane>
      </Tabs>
    </div>
  );
};

